"use client";
import {
  CollectionContextProvider,
  CollectionScopedContextProvider
} from "./FU7RTSEI.js";
import {
  createStoreContext
} from "./YIF72NQG.js";

// src/composite/composite-context.tsx
import { createContext } from "react";
var ctx = createStoreContext(
  [CollectionContextProvider],
  [CollectionScopedContextProvider]
);
var useCompositeContext = ctx.useContext;
var useCompositeScopedContext = ctx.useScopedContext;
var useCompositeProviderContext = ctx.useProviderContext;
var CompositeContextProvider = ctx.ContextProvider;
var CompositeScopedContextProvider = ctx.ScopedContextProvider;
var CompositeItemContext = createContext(
  void 0
);
var CompositeRowContext = createContext(
  void 0
);

export {
  useCompositeContext,
  useCompositeScopedContext,
  useCompositeProviderContext,
  CompositeContextProvider,
  CompositeScopedContextProvider,
  CompositeItemContext,
  CompositeRowContext
};
